(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/prolongwager.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/prolongwager.js');

'use strict';

svs.maltipset.models.ProlongWager = Backbone.Model.extend({
  log: new svs.core.log.Logger('svs.maltipset.models.ProlongWager'),

  getExtendedWagerInfo: function(successFn, errorFn) {
    if (this.get('bets') && this.get('bets').length) {
      successFn(this);
    } else {
      var url = '/player/1/wagers/' + this.get('wagerId');
      var self = this;
      var options = {
        method: 'GET',
        path: url
      };

      svs.core.jupiter.call(
        options,
        function(data) {
          self.set(data.wager.wager, { silent: true });
          self.set('properties', data.wager.properties, { silent: true });
          _.each(data.wager.wager.bets, function(bet) {
            bet.betProperties[0] =
                svs.maltipset.constants.BET_PROPERTIES.PROLONGATION;
            if (bet.productId === 'MAL') {
              self.set('malBoardData', bet.numberBoards, { silent: true });
            } else if (bet.productId === 'SPORTJOKER') {
              if (bet.numDraws > 0) {
                bet.betAmountSalesGroup1 = (
                  parseInt(bet.betAmountSalesGroup1, 10) / bet.numDraws
                ).toString();
              }
              self.set(
                {
                  sportkryssBoardData: bet.jokerBoards[0].boardData,
                  hasSportkryss: true,
                  sportkryssPrice: bet.rowPriceMulti * 10,
                  sportkryssBet: bet
                },
                { silent: true }
              );
            }
          });
          successFn(self);
        },
        function(error) {
          self.log.debug('Failed getting wager with id: ' +
                self.get('wagerId') +
                ', Error: ' +
                error.responseText);
          errorFn();
        }
      );
    }
  },

  prolongEdit: function() {
    var coupon = svs.maltipset.collections.coupons.getCurrentCoupon();
    var drawNum = coupon.get('draw').get('drawNumber');
    var boardData = [];
    var system = svs.maltipset.constants.SYSTEM.NO_SYSTEM;
    _.each(this.get('malBoardData'), function(data) {
      boardData.push(data.boardData);
    });
    if (this.get('systemType') === 'MSYS') {
      system = svs.maltipset.constants.SYSTEM.M_SYSTEM;
    } else if (this.get('systemType') === 'RSYS') {
      system = svs.maltipset.constants.SYSTEM.R_SYSTEM;
    }
    coupon.updateNumWeeks(this.get('totalDrawCount'));
    coupon.updateSportkryss(this.get('sportkryssBet'));
    coupon.prolong(true);

    svs.maltipset.models.storageCoupon.storeSelectedMatches(
      drawNum,
      system,
      boardData
    );
  },

  setProlongData: function() {
    var coupon = svs.maltipset.collections.coupons.getCurrentCoupon();
    var drawNum = coupon.get('draw').get('drawNumber');

    _.each(this.get('bets'), function(bet) {
      bet.drawNum = bet.productId === 'SPORTJOKER' ? null : drawNum;
      _.each(bet.numberBoards, function(numberBoard) {
        numberBoard.numSelections =
            numberBoard.systemType[0] === 'SROW' ?
              svs.maltipset.constants.NUMBER_OF_MATCHES_TO_SELECT_NOSYSTEM :
              numberBoard.systemNum;
      });
    });
    coupon.set(
      {
        totalCost: this.get('betAmount'),
        hasSportkryssBet: this.get('hasSportkryssBet'),
        totalCompleteRows: this.get('rowCount'),
        prolongWager: this,
        isValid: true
      },
      { silent: true }
    );

    coupon.updateNumWeeks(this.get('totalDrawCount'));
    coupon.updateSportkryss(this.get('sportkryssBet'), true);
  }
});


 })(window);